import { ChangeDetectionStrategy, Component, Input, ViewContainerRef } from '@angular/core';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingSpinnerComponent {
  @Input() public showSpinner = false;

  constructor(public vcRef: ViewContainerRef) {}
}
